// extracted by css-extract-rspack-plugin
export default {"customerStory":"FlexSuiteRiverBreakout-module__customerStory___9h5D","customerStoryLogo":"FlexSuiteRiverBreakout-module__customerStoryLogo__KYlYz"};